module.exports = __webpack_public_path__ + "img/up-butterfly.1238e1e7.svg";